var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g(_vm._b({class:{
    'breakdance-icon': true,
    'breakdance-icon--clickable': _vm.hasClickEvent
  },style:({
    width: `${_vm.size}px`,
    height: _vm.heightAuto ? 'auto' : `${_vm.size}px`,
    transform: _vm.rotate ? `rotate(${_vm.rotate}deg)` : ''
  })},'div',_vm.$attrs,false),_vm.$listeners),[_c('RawIcon',{attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }